import { render, staticRenderFns } from "./BulkOperationButtons.vue?vue&type=template&id=a5874020&scoped=true&"
import script from "./BulkOperationButtons.vue?vue&type=script&lang=js&"
export * from "./BulkOperationButtons.vue?vue&type=script&lang=js&"
import style0 from "./BulkOperationButtons.vue?vue&type=style&index=0&id=a5874020&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5874020",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VList,VListItem,VListItemContent,VListItemTitle,VMenu})
